import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const STATUT_STYLES = {
  disponible: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30",
  preattribuee: "bg-sky-500/15 text-sky-600 dark:text-sky-400 border-sky-500/30",
  attribuee: "bg-primary/15 text-primary border-primary/30",
  receptionnee: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30",
  attente_constatation: "bg-red-500/15 text-red-600 dark:text-red-400 border-red-500/30",
  inactive: "bg-secondary text-muted-foreground border-border",
};

export function StatutBadge({ statut, label }) {
  return (
    <span className={`inline-flex items-center text-[11px] font-semibold px-2 py-0.5 rounded-full border whitespace-nowrap ${STATUT_STYLES[statut] || STATUT_STYLES.inactive}`}>
      {label || statut}
    </span>
  );
}

export function fmtDateHeure(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${d.toLocaleDateString("fr-FR")} ${d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}`;
}

export function nomChauffeur(c) {
  return c ? `${c.prenom || ""} ${c.nom || ""}`.trim() : "—";
}

export function defautTexte(d) {
  return `${d.categorie_label || d.categorie} : ${d.etat || ""}${d.detail ? (d.etat ? " — " : "") + d.detail : ""}`;
}

/** Données de référence communes aux pages scans. */
export function useScansData() {
  const [scans, setScans] = useState([]);
  const [tournees, setTournees] = useState([]);
  const [chauffeurs, setChauffeurs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    const [s, t, l, c] = await Promise.all([
      api.get("/scans"), api.get("/tournees"), api.get("/livreurs"), api.get("/scans/categories-defauts"),
    ]);
    setScans(s.data); setTournees(t.data.tournees); setChauffeurs(l.data); setCategories(c.data);
    setLoading(false);
  }, []);
  const reloadScans = useCallback(async () => {
    const { data } = await api.get("/scans");
    setScans(data);
  }, []);
  useEffect(() => { reload().catch(() => setLoading(false)); }, [reload]);
  return { scans, tournees, chauffeurs, categories, loading, reload, reloadScans };
}
